export enum UserRole {
    Administrator = 'Administrator',
    ContentManager = 'ContentManager',
    Support = 'Support',
    Creator = 'Creator',
    Publisher = 'Publisher',
    Developer = 'Developer',
    Tester = 'Tester'
}

export enum Permission {
    None            = 0,
    Test            = 1,
    View            = 2,
    UpdateContent   = 4,
    UpdateMetadata  = 8,
    PublishContent  = 16,
    PublishMetadata = 32,
    ManageSales     = 64,
    Full            = 128,
    Admin           = 256,
    All             = Test | View | UpdateContent | UpdateMetadata | PublishContent | PublishMetadata | ManageSales | Admin | Full
}

export function getRolePermissions(role: string): Permission {
    switch (role) {
        case UserRole.Administrator: return Permission.All;
        case UserRole.ContentManager: return Permission.All & ~Permission.Admin;
        case UserRole.Support: return Permission.All & ~Permission.Admin;
        case UserRole.Publisher: return Permission.All & ~Permission.Admin & ~Permission.Full;
        case UserRole.Developer: return Permission.View | Permission.UpdateContent | Permission.Test;
        case UserRole.Tester: return Permission.Test;
        default: return Permission.None;
    }
}

export class User {
    id?: string;
    _etag?: string;
    created?: string;
    modified?: string;
    email: string = '';
    name: string = '';
    gamerTag: string = '';
    xuid: string = '';
    psnAccountName: string = '';
    psnAccountId: string = '';
    isApproved: boolean = false;
    features: any = {};
    role: UserRole = UserRole.Creator;
    creators: { [key: string]: string } = {};
}
